"use client";
import {CSSProperties, JSX, RefObject} from "react";
import {exo2SemiBold, ralewayBold, montserratRegular, exo2Bold} from "@@/utils/fonts";
import useAppearOnScroll from "@@/hooks/useAppearsOnScroll";
import ListenSVG from "@@/public/img/about/listen.svg";
import IdeaSVG from "@@/public/img/about/idea.svg";
import StarSVG from "@@/public/img/about/star.svg";
import HandsSVG from "@@/public/img/about/hands.svg";
import CareSVG from "@@/public/img/about/our-mission/takeCare.svg";
import WallSVG from "@@/public/img/about/our-mission/wall.svg";
import InstallSVG from "@@/public/img/about/our-mission/install.svg";
import BMS from "@@/public/img/greenplayer/BMS.svg";
import QMS from "@@/public/img/greenplayer/QMS.svg";
import Funeral from "@@/public/img/greenplayer/funeral.svg";
import KioskTouch from "@@/public/img/greenplayer/kiosk-touch.svg";
import KioskTicket from "@@/public/img/greenplayer/kiosk-ticket.svg";
import DoctorList from "@@/public/img/greenplayer/Doctor-list.svg";
import Airport from "@@/public/img/greenplayer/Airport.svg";
import Services from "@@/public/img/greenplayer/Services.svg";
import Analytics from "@@/public/img/greenplayer/Analytics.svg";
import Meeting from "@@/public/img/greenplayer/Meeting.svg";
import Ihospital from "@@/public/img/greenplayer/Ihospital.svg";
import Transport from "@@/public/img/greenplayer/Transport.svg";
import Smile from "@@/public/img/kiosks/smile.svg";
import IdCard from "@@/public/img/kiosks/idCard.svg";
import Ticket from "@@/public/img/kiosks/ticket.svg";
import Direction from "@@/public/img/kiosks/direction.svg";
import Repair from "@@/public/img/development/repair.svg"

interface Props {
    title: string;
    subTitle?: string;
    items: {
        icon: string;
        title: string;
        desc: string;
        iconSrc? : string;
        animation?: {
            ref: RefObject<HTMLLIElement | null>;
            className: string;
            style: CSSProperties;
        }[];
    }[]
    sectionId?: string;
    cardClassName?:string;
}

export default function OurValues({ title, subTitle, items, sectionId, cardClassName }: Props): JSX.Element {

    const titleAnim = useAppearOnScroll<HTMLHeadingElement>({ from: "fromBottom", duration: 800, delay: 0 });

    const subTitleAnim = useAppearOnScroll<HTMLHeadingElement>({ from: "fromBottom", duration: 800, delay: 200});

    // On ajoute dynamiquement les animations, sans muter les props
    const animatedItems = Array.isArray(items)
        ? items.map((item, index) => {
            if(item.icon == "hear") item.iconSrc = ListenSVG.src;
            if(item.icon == "idea") item.iconSrc = IdeaSVG.src;
            if(item.icon == "star") item.iconSrc = StarSVG.src;
            if(item.icon == "hands") item.iconSrc = HandsSVG.src;
            if(item.icon == "care") item.iconSrc = CareSVG.src;
            if(item.icon == "wall") item.iconSrc = WallSVG.src;
            if(item.icon == "install") item.iconSrc = InstallSVG.src;
            if(item.icon == "BMS") item.iconSrc = BMS.src;
            if(item.icon == "QMS") item.iconSrc = QMS.src;
            if(item.icon == "funeral") item.iconSrc = Funeral.src;
            if (item.icon == "kiosk-touch") item.iconSrc = KioskTouch.src;
            if (item.icon == "kiosk-ticket") item.iconSrc = KioskTicket.src;
            if (item.icon == "Doctor-list") item.iconSrc = DoctorList.src;
            if (item.icon == "Airport") item.iconSrc = Airport.src;
            if (item.icon == "Service") item.iconSrc = Services.src;
            if (item.icon == "Analytics") item.iconSrc = Analytics.src;
            if (item.icon == "Meeting") item.iconSrc = Meeting.src;
            if (item.icon == "Ihospital") item.iconSrc = Ihospital.src;
            if (item.icon == "Transport") item.iconSrc = Transport.src;
            if(item.icon == "smile") item.iconSrc = Smile.src;
            if(item.icon == "id") item.iconSrc = IdCard.src;
            if(item.icon == "ticket") item.iconSrc = Ticket.src;
            if(item.icon == "direction") item.iconSrc = Direction.src;
            if(item.icon == "repair") item.iconSrc = Repair.src;

            const animation = useAppearOnScroll<HTMLLIElement>({
                from: "fromBottom",
                duration: 800,
                delay: (index % 4) * 100,
            });
            return { ...item, animation };
        })
        : [];


    return (
        <section className={`px-11 mt-5 color-dark mb-5`} id={`ourValues`}>
            <div className={`d-flex flex-column gap-5 p-5`}>
                <div className={`d-flex flex-column gap-2`}>
                    <h2
                        ref={titleAnim.ref}
                        className={` ${exo2Bold.className} ${titleAnim.className}`}
                        style={titleAnim.style} dangerouslySetInnerHTML={{__html: title}}>
                    </h2>
                    {subTitle && (
                        <h3 ref={subTitleAnim.ref}
                            className={` ${exo2SemiBold.className} ${subTitleAnim.className}`}
                            style={subTitleAnim.style} dangerouslySetInnerHTML={{__html: subTitle}}>
                        </h3>
                    )}
                </div>
                <ul className={`list-none d-flex w-100 space-between gap-5 flex-wrap`} >
                    {animatedItems.map((item, index) => (
                        <li
                            key={index}
                            ref={item.animation.ref}
                            className={`d-flex flex-column w-100 mw-270 gap-1 ${item.animation.className} ${cardClassName}`}
                            style={item.animation.style}
                        >
                            <span className={`iconCard`} style={{background: `url(${item.iconSrc})`}}></span>
                            {subTitle ? (
                                <h4 className={`${exo2SemiBold.className}`} dangerouslySetInnerHTML={{__html: item.title}}></h4>
                            ) : (
                                <h3 className={`${exo2SemiBold.className}`} dangerouslySetInnerHTML={{__html: item.title}}></h3>
                            )}
                            <p className={montserratRegular.className}>{item.desc}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}